module.exports = {
	"shared": {
		"vod-settings": {
			"get": {
				"name": "shared.vod-settings.get",
				"service": "catalog",
				"id": 1010
			},
			"update": {
				"name": "shared.vod-settings.update",
				"service": "catalog",
				"id": 1011
			}
		},
		"channel": {
			"get": {
				"id": 1012,
				"name": "shared.channel.get",
				"service": "catalog"
			},
			"update": {
				"id": 1013,
				"name": "shared.channel.update",
				"service": "catalog"
			},
			"video": {
				"get": {
					"id": 1014,
					"name": "shared.channel.video.get",
					"service": "catalog"
				}
			},
			"payment": {
				"get": {
					"id": 1016,
					"name": "shared.channel.payment.get",
					"service": "catalog"
				}
			},
			"videos": {
				"list": {
					"id": 1017,
					"name": "shared.channel.videos.list",
					"service": "catalog"
				}
			}
		},
		"channels": {
			"list": {
				"id": 1018,
				"name": "shared.channels.list",
				"service": "catalog"
			},
			"search": {
				"id": 1019,
				"name": "shared.channels.search",
				"service": "catalog"
			}
		},
		"payments": {
			"paypal": {
				"get": {
					"id": 2019,
					"name": "shared.payments.paypal.get",
					"service": "dgs"
				},
				"disconnect": {
					"id": 2020,
					"name": "shared.payments.paypal.disconnect",
					"service": "dgs"
				}
			}
		},
		"premium-info": {
			"get": {
				"id": 3021,
				"name": "shared.premium-info.get",
				"service": "billing"
			}
		},
		"general": {
			"unhandled-exception": {
				"id": 4000,
				"name": "unhandled-exception",
				"service": "unknown"
			}
		},
		"experiments": {
			"get": {
				"id": 1018,
				"name": "shared.experiments.get",
				"service": "catalog"
			}
		}
	},
	"widget": {
		"stats": {
			"report": {
				"id": 14011,
				"name": "widget.stats.report",
				"service": "counters"
			}
		}
	},
	"dashboard": {
		"channel": {
			"remove": {
				"id": 31010,
				"name": "dashboard.channel.remove",
				"service": "catalog"
			},
			"video": {
				"update": {
					"id": 31011,
					"name": "dashboard.channel.video.update",
					"service": "catalog"
				}
			},
			"videos": {
				"add": {
					"id": 31012,
					"name": "dashboard.channel.videos.add",
					"service": "catalog"
				},
				"move": {
					"id": 31013,
					"name": "dashboard.channel.videos.move",
					"service": "catalog"
				},
				"remove": {
					"id": 31014,
					"name": "dashboard.channel.videos.remove",
					"service": "catalog"
				}
			}
		},
		"file": {
			"upload": {
				"id": 35015,
				"name": "dashboard.file.upload",
				"service": "files"
			}
		},
		"stats": {
			"overview": {
				"top_videos": {
					"get": {
						"id": 34016,
						"name": "dashboard.stats.overview.top_videos.get",
						"service": "counters"
					}
				}
			}
		},
		"video": {
			"get": {
				"id": 31017,
				"name": "dashboard.video.get",
				"service": "catalog"
			},
			"update": {
				"id": 31018,
				"name": "dashboard.video.update",
				"service": "catalog"
			},
			"upload": {
				"id": 31022,
				"name": "dashboard.video.upload",
				"service": "catalog"
			},
			"reupload": {
				"id": 31023,
				"name": "dashboard.video.reupload",
				"service": "catalog"
			}
		},
		"videos": {
			"list": {
				"id": 31019,
				"name": "dashboard.videos.list",
				"service": "catalog"
			},
			"search": {
				"id": 31020,
				"name": "dashboard.videos.search",
				"service": "catalog"
			},
			"update": {
				"id": 31021,
				"name": "dashboard.videos.update",
				"service": "catalog"
			},
			"remove": {
				"id": 31024,
				"name": "dashboard.videos.remove",
				"service": "catalog"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/bi/bi-errors-catalog.json
// module id = 1104
// module chunks = 0 1 2 3 4